var React = require('react');

function ArrowLeftInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.2503 23.25L1.5303 12.53C1.38961 12.3895 1.31055 12.1988 1.31055 12C1.31055 11.8012 1.38961 11.6105 1.5303 11.47L12.2503 0.75","stroke":"#1E222D","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

ArrowLeftInline.defaultProps = {"width":"13","height":"24","viewBox":"0 0 13 24","fill":"none"};

module.exports = ArrowLeftInline;

ArrowLeftInline.default = ArrowLeftInline;
